module.exports = __webpack_public_path__ + "img/img5.0394d6b6.png";